import { createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.includes.js";
import { TREE_URL } from "@/api/system/menu";
import { createTableActionItem, createTableColumn, createTableHeaderButton } from "@/component-create/utils/create-table-column";
import { Table } from "@/component-create/Table";
import { MENU_STATUS, MENU_STYLE, MENU_VISIBILITY } from "@/constant/system/code";
import { formatter as _formatter } from "@/utils/common";
import SvgIcon from '@/components/svg-icon/SvgIcon.vue';
import XIcon from '@/components/x-icon/XIcon.vue';
import { ElTag } from "element-plus";
import 'element-plus/es/components/tag/style/css'

export function createTable(el, row, table) {
  var _table = new Table(el, column(row), headerButtons(table), {
    border: true,
    rowKey: 'id'
  }, TREE_URL, {
    responseConfig: {
      total: function total() {
        return 0;
      },
      data: function data(_data) {
        return _data;
      }
    }
  });
  return _table;
}
function column(rowHandler) {
  var col = [createTableColumn('菜单名称', 'menuName', '300'), createTableColumn('图标', '', '60', 'center', {
    slot: function slot(row) {
      if (row.icon && row.icon.includes('el-icon')) {
        return h(_createVNode(XIcon, {
          "style": {
            width: '14px',
            height: '14px'
          },
          "icon": row.icon
        }, null));
      } else if (row.icon) {
        return h(_createVNode(SvgIcon, {
          "style": {
            width: '14px',
            height: '14px'
          },
          "icon-class": row.icon
        }, null));
      } else {
        return h(_createVNode("i", null, null));
      }
    }
  }), createTableColumn('样式', '', '80', 'center', {
    slot: function slot(row) {
      if (row.menuStyle === MENU_STYLE.CATALOG) {
        return h(_createVNode(ElTag, {
          "size": "small"
        }, {
          default: function _default() {
            return [_createTextVNode("\u76EE\u5F55")];
          }
        }));
      } else if (row.menuStyle === MENU_STYLE.MENU) {
        return h(_createVNode(ElTag, {
          "type": "success",
          "size": "small"
        }, {
          default: function _default() {
            return [_createTextVNode("\u9875\u9762")];
          }
        }));
      }
      return h(_createVNode("i", null, null));
    }
  }), createTableColumn('路由地址', 'path', undefined, 'center', {
    showOverflowTooltip: true
  }), createTableColumn('组件路径', 'component', '300', undefined, {
    showOverflowTooltip: true
  }), createTableColumn('顺序', 'sort', '60', 'center'), createTableColumn('可见', 'visible', '60', 'center', {
    formatter: function formatter(row) {
      return _formatter(MENU_VISIBILITY, row.status);
    }
  }), createTableColumn('状态', '', '80', 'center', {
    slot: function slot(row) {
      if (row.status === MENU_STATUS.DISABLED.CODE) {
        return h(_createVNode(ElTag, {
          "type": "danger",
          "size": "small"
        }, {
          default: function _default() {
            return [_createTextVNode("\u505C\u7528")];
          }
        }));
      } else {
        return h(_createVNode(ElTag, {
          "type": "success",
          "size": "small"
        }, {
          default: function _default() {
            return [_createTextVNode("\u542F\u7528")];
          }
        }));
      }
    }
  }), createTableColumn('创建时间', 'createdAt', '150', 'center'), createTableColumn('操作', undefined, '200', 'center', {
    fixed: 'right',
    controller: function controller(row) {
      var ctrs = [];
      if (row.menuStyle === MENU_STYLE.MENU) {
        ctrs.push(createTableActionItem('操作', 'Key', rowHandler.rowHandle));
      } else if (row.menuStyle === MENU_STYLE.CATALOG) {
        ctrs.push(createTableActionItem('新增', 'Plus', rowHandler.rowAdd));
      }
      ctrs.push(createTableActionItem('编辑', 'Edit', rowHandler.rowEdit), createTableActionItem('删除', 'Delete', rowHandler.rowDelete));
      return ctrs;
    }
  })];
  return col;
}
/**
 * 表格头部按钮
 */
function headerButtons(table) {
  return [createTableHeaderButton('刷新', 'primary', 'Search', table.searchFn), createTableHeaderButton('新增', 'primary', 'Plus', table.addFn)];
}